import { useState } from "react";
import { ArrowRight, X } from "lucide-react";
import { API, attribution, http } from "../../lib/api";
import { SERVICE_OPTIONS } from "../../lib/brand";
import { QuoteSuccess } from "./QuoteSuccess";

const COPY = {
  bulk: ["Bulk procurement", "Request a bulk quote", "Tell us the quantity and delivery location — we’ll send a tender-ready quotation."],
  tender: ["GeM & e-tender desk", "Request a tender quote", "Share your tender reference and bid deadline. Our tender desk responds within one working day."],
  default: ["Talk to a specialist", "Plan your response fleet", "Share a few details and our team will prepare the right technical recommendation."],
};

export function QuoteModal({ close, product, variant, source = "quote-modal", service }) {
  const kind = product ? "bulk" : variant === "tender" ? "tender" : "default";
  const [form, setForm] = useState({ name: "", phone: "", email: "", service: service || (kind === "bulk" ? SERVICE_OPTIONS[0] : kind === "tender" ? "GeM & E-Tender Support" : "Fire Truck Manufacturing"), message: "", quantity: 1, tender_ref: "", deadline: "" });
  const [sent, setSent] = useState(false), [loading, setLoading] = useState(false), [error, setError] = useState("");
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  async function submit(e) {
    e.preventDefault(); setLoading(true); setError("");
    const extra = kind === "tender" ? `Tender ref: ${form.tender_ref || "-"} | Bid deadline: ${form.deadline || "-"}\n` : "";
    const { tender_ref, deadline, quantity, ...rest } = form;
    try {
      await http.post("/leads", { ...rest, ...attribution(), page: window.location.pathname, message: extra + form.message, product: product?.name || "", quantity: kind === "bulk" ? Number(quantity) : null, form_source: kind === "default" ? source : `${kind}-quote` });
      setSent(true);
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Please check the highlighted details, or call us directly.");
    } finally { setLoading(false); }
  }

  const [eyebrow, title, intro] = COPY[kind];
  return (
    <div className="modal-backdrop" role="presentation" onClick={(e) => e.target === e.currentTarget && close()}>
      <div className="modal" data-testid="quote-modal">
        <button className="icon-btn modal-close" onClick={close} data-testid="quote-modal-close" aria-label="Close"><X /></button>
        {sent ? <QuoteSuccess product={product} close={close} catalogUrl={`${API}/catalog.pdf`} /> : (
          <>
            <p className="eyebrow">{eyebrow}</p>
            <h2 data-testid="quote-modal-title">{title}</h2>
            <p className="modal-intro">{intro}</p>
            {product && <div className="quote-product" data-testid="quote-product-chip"><img src={product.image} alt="" /><div><small>{product.category}</small><strong>{product.name}</strong><span>MOQ {product.moq}</span></div></div>}
            <form onSubmit={submit} data-testid="consultation-form">
              <div className="form-grid">
                <label>Name<input required value={form.name} onChange={set("name")} data-testid="lead-name-input" /></label>
                <label>Phone<input required value={form.phone} onChange={set("phone")} data-testid="lead-phone-input" /></label>
              </div>
              <label>Work email<input type="email" required value={form.email} onChange={set("email")} data-testid="lead-email-input" /></label>
              {kind === "bulk" && <label>Quantity required<input type="number" min="1" max="10000" required value={form.quantity} onChange={set("quantity")} data-testid="lead-quantity-input" /></label>}
              {kind === "tender" && <div className="form-grid"><label>Tender / GeM bid no.<input value={form.tender_ref} onChange={set("tender_ref")} placeholder="GEM/2026/B/…" data-testid="lead-tender-ref-input" /></label><label>Bid deadline<input type="date" value={form.deadline} onChange={set("deadline")} data-testid="lead-deadline-input" /></label></div>}
              {kind !== "bulk" && <label>What do you need?<select value={form.service} onChange={set("service")} data-testid="lead-service-select">{SERVICE_OPTIONS.map((x) => <option key={x}>{x}</option>)}</select></label>}
              <label>Project notes<textarea value={form.message} onChange={set("message")} placeholder="Capacity, delivery location, site requirements…" data-testid="lead-message-input" /></label>
              {error && <div className="form-error" data-testid="lead-form-error">{error}</div>}
              <button className="button button-orange full" disabled={loading} data-testid="lead-submit-button">{loading ? "Sending…" : kind === "default" ? "Request technical consultation" : "Submit quote request"}<ArrowRight size={17} /></button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
